import log from "cslog";
import React from "react";
import AIHome from "../ai_home/AIHome";
import AIImageGen from "../ai_img_gen/AIImageGen";
import AllOrganizations from "../all_organizations/AllOrganizations";
import AllUsers from "../all_users/AllUsers";
import AccountSetting from "../auth/AccountSetting";
import ChangePassword from "../auth/ChangePassword";
import UpdateProfile from "../auth/UpdateProfile";
import BrandAssets from "../brand_assets/BrandAssets";
import CollectionCreateComponent from "../collections/CollectionCreateComponent";
import ContentCalender from "../content_calender/ContentCalender";
import ContentCalenderNew from "../content_calender_new/ContentCalenderNew";
import CreationsHome from "../creations/CreationsHome";
import CreateTable from "../database/table/CreateTable";
import EditTable from "../database/table/EditTable";
import FestivalManager from "../festivals/FestivalManager";
import FileMaster from "../file_master/FileMaster";
import GraphicsManager from "../graphics_manager/GraphicsManager";
import Linkedin_posts from "../linkedin_posts/LinkedinPosts";
import MyCollections from "../my_collections/MyCollections";
import SchedulePost from "../SchedulePost/SchedulePost";
import NewHome from "../new_home/NewHome";
import PresetManager from "../preset_manager/PresetManager";
import QZeroTest from "../q0/QZeroTest";
import mapping_ecom from "../qbuilt_ecommerce";
import EnquiryList from "../qbuilt_enquiry/EnquiryList";
import ManageBrands from "../qbuilt_settings/ManageBrands";
import OrgnaizationSettings from "../qbuilt_settings/OrganizationSettings";
import QurealForm from "../qforms/QurealForm";
import AIModelManager from "../qmade/creator/AIModelManager";
import CreativeNew from "../qmade/creator/CreativeNew";
import CreationSingle from "../qmade/creator/creationdetails/CreationSingle";
import FileBrowser from "../qmade/drive/FileBrowser";
import PricingPlans from "../qmade/pricingplans/PricingPlans";
import PricingPlansCompare from "../qmade/pricingplanscompare/PricingPlansCompare";
import QurealBlogPosts from "../qureal_blogs/QurealBlogPosts";
import Sandbox from "../sandbox/Sandbox";
import Sandbox2 from "../sandbox/Sandbox2";
import TemplatesManager from "../template_manager/TemplatesManager";
import TrendsNew from "../trends/TrendsNew";
import DashboardDesign from "../dashboards/DashboardDesign";
import CategoryMap from "../desing_admin/CategoryMap";
import ConceptPresetManager from "../preset_manager/ConceptPresetManager";
import SocialAccounts from "../social_media/SocialAccounts";
import BillingPage from "../billing/BillingPage";
import FactoryHome from "../q0/FactoryHome";
// import MockupMaker from "../mockup_maker/MockupMaker";

const MockupMaker = React.lazy(() => import("../mockup_maker/MockupMaker"));

// import { CateSandbox } from "../sandbox/CateSandbox";
// import CateSandbox from "../sandbox/CateSandbox2";
// import CateSandbox from "../sandbox/CateSandbox3";

const MAPPING = {
    ...mapping_ecom,
};

function QBuilt({ screen, params, me }) {
    switch (screen) {
        case "home":
            return <NewHome me={me} />;
        case "new_home":
            return <AIHome me={me} />;
        case "file_master":
            return <FileMaster />;
        case "preset_manager":
            return <PresetManager />;
        case "concept_preset_manager":
            return <ConceptPresetManager me={me} />;
        case "q0_test":
            return <QZeroTest me={me} />;
        case "account_settings":
            return <AccountSetting />;
        case "sandbox_2":
            return <Sandbox2 me={me} />;
        // return <CateSandbox />;
        case "social_accounts":
            return <SocialAccounts me={me} />;
        case "festival_manager":
            return <FestivalManager me={me} />;
        case "sandbox":
            return <Sandbox me={me} />;
        case "all_users":
            return <AllUsers me={me} />;
        case "graphics_manager":
            return <GraphicsManager me={me} />;
        case "all_orgs":
            return <AllOrganizations me={me} />;
        case "trends_home":
            // return <TrendsHome me={me} />;
            return <TrendsNew me={me} />;
        case "change_password":
            return <ChangePassword />;
        case "dashboard_design":
            return <DashboardDesign me={me} />;
        case "update_profile":
            return <UpdateProfile />;
        case "settings_org":
            return <OrgnaizationSettings />;
        case "manage_brand":
            return <ManageBrands />;
        case "content_calender":
            return <ContentCalender me={me} />;
        case "category_map":
            return <CategoryMap me={me} />;
        case "dashboard_design":
            return <DashboardDesign me={me} />;
        case "content_calender_new":
            return <ContentCalenderNew me={me} />;
        case "brand_assets":
            return <BrandAssets me={me} />;
        case "model_manager":
            return <AIModelManager me={me} />;
        case "billing_page":
            return <BillingPage me={me} />;
        case "schedule_post":
            return <SchedulePost me={me} />;
        case "factory":
            return <FactoryHome me={me} />;
        case "templates_manager":
            return <TemplatesManager me={me} />;
        case "ai_image_gen":
            return <AIImageGen me={me} />;
        case "blogscreen":
            return <QurealBlogPosts me={me} />;
        case "linkedin":
            return <Linkedin_posts me={me} />;
        case "my_collections":
            return <MyCollections me={me} />;
        case "file_browser":
            return <FileBrowser />;
        //Creatives
        case "creative_new":
            return <CreativeNew />;
        case "creative_all_creations":
            // return <AllCreations />;
            return <CreationsHome me={me} />;
        case "creative_edit":
            return <CreationSingle params={params} />;
        case "pricing_plan":
            return <PricingPlans />;
        case "pricing_plan_compare":
            return <PricingPlansCompare />;
        //Database
        case "db_create_table":
            return <CreateTable />;
        case "db_create_form":
            return (
                <QurealForm
                    id={8}
                    record_id={1}
                    wrapperStyle={{
                        background: "white",
                    }}
                />
            );
        case "qdb_edit_table":
            return <EditTable id="qdb_lookup" params={params} />;
        case "qdb_create_collection":
            return <CollectionCreateComponent />;
        case "enquiry_all":
            return <EnquiryList />;
        case "enquiry_open":
            return <EnquiryList status="active" />;
        case "enquiry_closed":
            return <EnquiryList status="closed" />;
        case "enquiry_hold":
            return <EnquiryList status="on_hold" />;
        case "mockup_maker":
            return <MockupMaker />
        default:
            log.d(MAPPING, "qbuilt mapping");
            if (Object.keys(MAPPING).includes(screen)) {
                return MAPPING[screen];
            }
            return (
                <div
                    style={{
                        width: "100%",
                        height: "100vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <h2
                        style={{
                            color: "grey",
                        }}
                    >
                        QBuilt Component not found: {screen}
                    </h2>
                </div>
            );
    }
}

export default QBuilt;
